import type { NextPage } from 'next';
import { LegalDisclaimerComponent, getStaticPropsNicho } from 'ui';

const PageLegalDisclaimer: NextPage = () => {
	return <LegalDisclaimerComponent domain="www.altairstudios.es" />;
};

export const getStaticProps = getStaticPropsNicho();
export default PageLegalDisclaimer;
